import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OpenZenDeskModule } from '@fantaz/shared/directives/open-zendesk';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { AlertComponent, AlertMessageComponent } from '@fantaz/ui';
import { MatchMakingDialogComponent } from './match-making-dialog/match-making-dialog.component';
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    OpenZenDeskModule,
    CurrencyModule,
    AlertComponent,
    AlertMessageComponent,
  ],
  exports: [MatchMakingDialogComponent],
  declarations: [MatchMakingDialogComponent],
})
export class TournamentsUiMatchMakingDialogModule {}
